import styled from "styled-components";
import Text from "../Text";
import { focusVisibleStyle } from "../focus";
import { useThemeDefaults } from "../utils";
var InfoIcon = useThemeDefaults(function () {
  return {
    textStyle: "bodySmallEmph",
    children: '?',
    as: "div"
  };
}, styled(Text).withConfig({
  displayName: "InfoIcon",
  componentId: "sc-1r2c4l3-0"
})(["display:inline-block;border-radius:50%;background-color:", ";color:", ";width:", ";height:", ";transform:translateY(", ");text-align:center;", ""], function (props) {
  return props.theme.colors[props.bg] || props.bg || props.theme.colors.footerBg;
}, function (props) {
  return props.theme.colors[props.color] || props.color || props.theme.colors.labelPlaceholder;
}, function (props) {
  return props.width || "17px";
}, function (props) {
  return props.height || "17px";
}, function (props) {
  return props.translateY;
}, focusVisibleStyle));
export default InfoIcon;